import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { DateTimePicker } from 'react-widgets'
import { Selector } from '@leverege/ui-elements'
import style from './style.css'

const classnames = require( 'classnames' )
const { LabelGroup } = require( '../../views' )
// const { HistoryActions, EventActions } = require( '../../actions' )
const util = require( './util' )

const PER_PAGE_VALUES = [
  { name : '1', value : 1 },
  { name : '5', value : 5 },
  { name : '10', value : 10 },
  { name : '50', value : 50 },
  { name : '100', value : 100 },
  { name : '500', value : 500 },
  { name : '1000', value : 1000 }
]

class SimpleTimeEditor extends React.Component {

  static propTypes = {
    query : PropTypes.object.isRequired,
    queryName : PropTypes.string.isRequired,
    pagination : PropTypes.object.isRequired,
    onChange : PropTypes.func.isRequired,
    syncWithLocation : PropTypes.func,
    history : PropTypes.object.isRequired,
    location : PropTypes.object.isRequired,
    actions : PropTypes.object.isRequired
  };

  static defaultProps = {
    syncWithLocation : () => {}
  };
  
  static TYPE = 'simpleTimeEditor';

  constructor( props, context ) {
    super( props, context )

    const { query } = this.props

    this.syncQueryToLocation( query )
  }

  syncQueryToLocation( query ) {
    const { syncWithLocation } = this.props
    syncWithLocation( query )
  }

  updateQuery( query ) {
    const { queryName, actions, dispatch } = this.props

    dispatch( actions.updateQuery( {
      name : queryName,
      query
    } ) )
    this.syncQueryToLocation( query )
  }

  handlePerPage = ( { value } ) => {
    const { onChange, pagination } = this.props
    onChange( { path : 'pagination', value : { ...pagination, perPage : value } } )
  }

  handleStart = ( start ) => {
    const { query, onChange, pagination } = this.props
    onChange( { path : 'pagination', value : { ...pagination, startIndex : 0 } } )

    this.updateQuery( {
      ...query,
      start
    } )
  }

  jumpToNow = () => {
    this.handleEnd( Date.now() )
  }

  handleEnd = ( end ) => {
    const { query, onChange, pagination } = this.props
    onChange( { path : 'pagination', value : { ...pagination, startIndex : 0 } } )

    this.updateQuery( {
      ...query,
      end
    } )
  }

  render() {
    const { query, pagination, className } = this.props
    return (
      <div className={classnames( style.filter, style.row, className )}>
        <div className={classnames( style.row, style.left )}>
          <LabelGroup>
            <label>
              History Data Points Per Page
            </label>
            <Selector
              className={style.perPageDropdown}
              values={PER_PAGE_VALUES}
              value={pagination.perPage}
              onChange={this.handlePerPage} />
          </LabelGroup>
        </div>
        <div className={classnames( style.row, style.right )}>
          <LabelGroup>
            <label>Start</label>
            <DateTimePicker
              onChange={this.handleStart}
              format="YYYY-MM-DDTHH:mm"
              value={query.start ? new Date( query.start ) : null} />
          </LabelGroup>
          <div className={style.endContainer}>
            <LabelGroup>
              <label>End</label>
              <DateTimePicker
                onChange={this.handleEnd}
                format="YYYY-MM-DDTHH:mm"
                value={query.end ? new Date( query.end ) : null} />
            </LabelGroup>
            <div onClick={this.jumpToNow} className={style.jump}>Jump to now</div>
          </div>
        </div>
      </div>
    )
  }
}

export default connect( state => ( { } ) )( SimpleTimeEditor )
